import { connect } from 'react-redux';
import classnames from 'classnames';
import { showInfoValues } from 'default-settings';

import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';

import { isPreviewHover, getInfoActionVisibility } from 'shared/selectors/app-settings';

import OverlayStripBase from 'widget/components/player-overlay/strip/strip-base';
import ElementSwitcher from 'shared/components/element-switcher/element-switcher';
import { RoundedIcon } from 'shared/components/icon/icon';
import { GenericButton } from 'shared/components/button/button';

import styles from './thumbnail-overlay.styl';


const THUMB_PADDING = 24;


export class ThumbnailOverlayStripBase extends OverlayStripBase {

  static displayName = 'ThumbnailOverlayStrip';

  static propTypes = {
    isPreviewHover: React.PropTypes.bool,
    isTitleAlwaysShown: React.PropTypes.bool,
    isTitleNeverShown: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);

    const { durationStr } = this.props.videoItem;

    this.clampOptions = {
      ...this.clampOptions,
      truncateText: ` / ${durationStr}`,
      textAlign: 'center',
    };
  }

  get titleText() {
    return this.props.videoItem.title;
  }

  get shouldShowTitle() {
    return true;
  }

  get titleBlock() {
    if (this.props.isTitleNeverShown) {
      return null;
    }

    return (
      <div styleName="title-block">
        {this.title}
      </div>
    );
  }

  get smallPlayButton() {
    if (!this.playButtonText) {
      return null;
    }

    return (
      <GenericButton styleName="button play-button"
                     onClick={this.playSelectedVideo}>
        <RoundedIcon styleName="icon play-icon"
                     name="arrow-right-filled" />
      </GenericButton>
    );
  }

  get smallSubscribeButton() {
    if (!this.subscribeButtonText) {
      return null;
    }

    return (
      <GenericButton styleName="button small-subscribe-button"
                     onClick={this.openSubscription}>
        <RoundedIcon styleName="icon paid-icon"
                     name="paid" />
      </GenericButton>
    );
  }

  get smallPurchaseButton() {
    if (!this.purchaseButtonText) {
      return null;
    }

    return (
      <GenericButton styleName="button small-buy-button"
                     onClick={this.openPurchase}>
        <RoundedIcon styleName="icon paid-icon"
                     name="paid" />
      </GenericButton>
    );
  }

  get normalButtons() {
    const play = this.playButton;
    const subscribe = this.subscribeButton;
    const purchase = this.purchaseButton;

    const key = `${play ? '1' : ''}${subscribe ? '2' : ''}${purchase ? '3' : ''}`;

    return (
      <div styleName="buttons-wrapper"
           key={key}>
        {play}
        {subscribe || purchase}
      </div>
    );
  }

  get smallButtons() {
    return (
      <section styleName="buttons-wrapper">
        {this.smallPlayButton}
        {this.smallSubscribeButton || this.smallPurchaseButton}
      </section>
    );
  }

  get buttons() {
    const { width, isOnlySmallButtons } = this.props;

    if (isOnlySmallButtons) {
      return this.smallButtons;
    }

    return (
      <ElementSwitcher maxWidth={width - 2 * THUMB_PADDING}>
        {this.normalButtons}
        {this.smallButtons}
      </ElementSwitcher>
    );
  }

  render() {
    const {
      channelData, videoItem, className,
      isPreviewHover, isTitleAlwaysShown, isTitleNeverShown,
    } = this.props;

    if (!channelData || !videoItem) {
      return null;
    }

    const styleNames = classnames('overlay-wrapper', {
      'preview-hover': isPreviewHover,
      visible: isTitleAlwaysShown || isTitleNeverShown,
    });

    return (
      <div styleName={styleNames}
           className={className}>
        <div styleName="background" />
        <div styleName="content">
          <div styleName="top-content"
               dir="ltr">
            {this.titleBlock}
            {this.buttons}
          </div>
        </div>
      </div>
    );
  }
}

@connect(state => ({
  isPreviewHover: isPreviewHover(state),
  isTitleAlwaysShown: getInfoActionVisibility(state) === showInfoValues.ALWAYS,
  isTitleNeverShown: getInfoActionVisibility(state) === showInfoValues.NEVER,
}))
@VODBiEvents()
@VODCSSModules(styles)
export default class ThumbnailOverlayStrip extends ThumbnailOverlayStripBase {}



// WEBPACK FOOTER //
// ./src/widget/components/videos-list/strip/thumbnail-overlay/thumbnail-overlay.js